import {
  ServerTransactionBriefWithBookingLocationType,
  ServerTransactionToCalcBalanceType,
  ServerTransactionType,
  TRANSACTION_TYPES,
} from '@expane/data'
import {
  getTransactionsWithAllTypesRevenueOnAccount,
  getTransactionsWithBookingsWithoutRefunds,
} from 'logic/finances/filters'
import { calcValues } from '@expane/logic/utils'

// подсчёт общей суммы денег на всех счетах
export const calcTotalBalanceOnAllAccounts = (
  transactions: ServerTransactionToCalcBalanceType[],
) => {
  const result = { toAccountTotalValue: 0, fromAccountTotalValue: 0, totalValue: 0 }

  // исключаются транзакции перемещений между счетами
  const toAccount = transactions.filter(
    t => t.toAccountId !== null && t.type !== TRANSACTION_TYPES.operation.id,
  )
  const fromAccount = transactions.filter(
    t => t.fromAccountId !== null && t.type !== TRANSACTION_TYPES.operation.id,
  )

  result.toAccountTotalValue = toAccount ? calcValues(toAccount) : 0
  result.fromAccountTotalValue = fromAccount ? calcValues(fromAccount) : 0
  result.totalValue = result.toAccountTotalValue - result.fromAccountTotalValue

  return result
}

export const calcAllRevenueOnAccount = (id: number, transactions?: ServerTransactionType[]) => {
  const allTypesRevenueOnAccount = getTransactionsWithAllTypesRevenueOnAccount(id, transactions)

  return allTypesRevenueOnAccount ? calcValues(allTypesRevenueOnAccount) : 0
}

export const calcBookingsPayments = (
  transactions?: ServerTransactionType[] | ServerTransactionBriefWithBookingLocationType[],
): { bookingsTotalValue: number; bookingsQuantity: number } => {
  const result = {
    bookingsTotalValue: 0,
    bookingsQuantity: 0,
  }

  const bookingsPayments = transactions
    ? getTransactionsWithBookingsWithoutRefunds(transactions)
    : []

  result.bookingsQuantity = bookingsPayments.length
  result.bookingsTotalValue = calcValues(bookingsPayments)

  return result
}
